import React, { useState, useEffect } from 'react';
import { Music, Settings, LogOut, List, Newspaper, BarChart2, Wrench, Swords, Play, Square, Plus, SkipBack, SkipForward, Shuffle, Users, Heart, Send, Pencil, Save, X, Clock, User, Smartphone, MessageSquare, Trash2, Trophy, Star, Search, Store, Phone, MessageCircle, Monitor } from 'lucide-react';
import Player from './components/Player';
import AdminQueuePanel from './components/AdminQueuePanel';
import Battle from './components/Battle';
import './App.css';

function App() {
  const [view, setView] = useState('listener');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [adminTab, setAdminTab] = useState('dashboard');
  const [noticias, setNoticias] = useState([]);
  const [activeNewsIndex, setActiveNewsIndex] = useState(0);
  const [playlists, setPlaylists] = useState([]);
  const [allSongs, setAllSongs] = useState([]);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [playlistSongs, setPlaylistSongs] = useState([]);
  const [selectedSongsToAdd, setSelectedSongsToAdd] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [newsForm, setNewsForm] = useState({ titulo: '', contenido: '', documento_url: '' });
  const [uploadingDoc, setUploadingDoc] = useState(false);
  const [batallaActiva, setBatallaActiva] = useState(null);
  const [battleHistory, setBattleHistory] = useState([]);
  const [nuevaBatalla, setNuevaBatalla] = useState({ nombre: '', cancion_a_id: '', cancion_b_id: '', duracion_minutos: 15 });
  const [solicitudes, setSolicitudes] = useState([]);
  const [statsSolicitudes, setStatsSolicitudes] = useState(null);
  const [adminStats, setAdminStats] = useState({ confesiones: 0, solicitudes: 0, funas: 0 });
  const [playlistParaReproducir, setPlaylistParaReproducir] = useState([]);
  const [playlistActivaId, setPlaylistActivaId] = useState(null);
  const [indexActual, setIndexActual] = useState(0);
  const [nuevaPlaylist, setNuevaPlaylist] = useState({ nombre: '', descripcion: '' });
  const [oyentes, setOyentes] = useState(0);
  const [funas, setFunas] = useState([]);
  const [funaForm, setFunaForm] = useState({ zona: 'Frente a Pabellón', comentario: '', foto: null });
  const [mostrandoFunaForm, setMostrandoFunaForm] = useState(false);
  const [enviandoFuna, setEnviandoFuna] = useState(false);
  const [pausarNoticias, setPausarNoticias] = useState(false);
  const [uploadingSong, setUploadingSong] = useState(false);
  const [ytUrl, setYtUrl] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const [ytJobId, setYtJobId] = useState(null);
  const [ytDownloadMsg, setYtDownloadMsg] = useState('');
  const [cookiesStatus, setCookiesStatus] = useState({ cookies_configuradas: false, tamaño_bytes: 0 });
  const [uploadingCookies, setUploadingCookies] = useState(false);
  const [editingSong, setEditingSong] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatForm, setChatForm] = useState({ mensaje: '', autor: '' });
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [nominaciones, setNominaciones] = useState([]);
  const [liveQueue, setLiveQueue] = useState([]);
  const [isStopped, setIsStopped] = useState(false);
  const [quickSearch, setQuickSearch] = useState('');
  const [nombreNominado, setNombreNominado] = useState('');
  const [isNominating, setIsNominating] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [listenerSearch, setListenerSearch] = useState('');
  const [currentSongId, setCurrentSongId] = useState(null);
  const [currentSongTitle, setCurrentSongTitle] = useState('Detectando señal...');
  const [pymes, setPymes] = useState([]);
  const [isPymesLoading, setIsPymesLoading] = useState(false);
  const [pymeForm, setPymeForm] = useState({ nombre_pyme: '', descripcion: '', oferta: '', telefono: '', file: null });
  const [isUploadingPyme, setIsUploadingPyme] = useState(false);
  const [pymesAdmin, setPymesAdmin] = useState([]);
  const [selectedPymes, setSelectedPymes] = useState([]);

  const getFullUrl = (url) => {
    if (!url) return url;
    if (url.startsWith('/uploads') || url.startsWith('/docs')) {
      return `/api${url}`;
    }
    return url;
  };





  const chatEndRef = React.useRef(null);



  const handleYtDownload = async () => {
    if (!ytUrl) return;
    setIsDownloading(true);
    setYtDownloadMsg('Iniciando descarga...');
    try {
      const res = await fetch('/api/youtube/download-async', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url: ytUrl })
      });
      const data = await res.json();
      if (data.error) { alert('Error: ' + data.error); setIsDownloading(false); return; }
      setYtUrl('');
      setYtJobId(data.job_id);
      setYtDownloadMsg('Descargando audio...');
      // Polling
      const poll = setInterval(async () => {
        try {
          const r = await fetch('/api/youtube/download-status/' + data.job_id);
          const j = await r.json();
          if (j.estado === 'completado') {
            clearInterval(poll);
            setIsDownloading(false);
            setYtJobId(null);
            setYtDownloadMsg('');
            await loadAdminData();
            alert('Descargado: ' + j.titulo);
          } else if (j.estado === 'error') {
            clearInterval(poll);
            setIsDownloading(false);
            setYtJobId(null);
            setYtDownloadMsg('');
            alert('Error: ' + (j.error || 'No se pudo descargar'));
          } else {
            setYtDownloadMsg('Descargando... (' + j.estado + ')');
          }
        } catch(e) {}
      }, 3000);
    } catch (e) { alert('Error de conexión'); setIsDownloading(false); }
  };

  const fetchCookiesStatus = async () => {
    try {
      const r = await fetch('/api/youtube/cookies-status');
      const j = await r.json();
      setCookiesStatus(j);
    } catch (e) {}
  };

  const handleCookiesUpload = async (file) => {
    if (!file) return;
    setUploadingCookies(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await fetch('/api/youtube/upload-cookies', { method: 'POST', body: fd });
      const j = await r.json();
      if (j.ok) {
        alert('✅ Cookies subidas correctamente. Ahora podrás descargar cualquier video.');
        fetchCookiesStatus();
      } else {
        alert('❌ ' + (j.error || 'Error subiendo cookies'));
      }
    } catch (e) {
      alert('Error de conexión');
    } finally {
      setUploadingCookies(false);
    }
  };

  const [confesiones, setConfesiones] = useState([]);
  const [confesionesPendientes, setConfesionesPendientes] = useState([]);
  const [mostrandoConfesionForm, setMostrandoConfesionForm] = useState(false);
  const [enviandoConfesion, setEnviandoConfesion] = useState(false);
  const [confesionForm, setConfesionForm] = useState({ contenido: '', pseudonimo: '' });

  useEffect(() => { fetchCookiesStatus(); }, []);

  const fetchStatus = async () => {
    try {
      const res = await fetch('/api/player/current');
      if (res.ok) {
        const data = await res.json();
        setOyentes(data.oyentes || 0);
        if (data.id) {
          setCurrentSongId(data.id);
          setCurrentSongTitle(data.titulo || 'Radio ASENF');
        }
        
        try {
          const qRes = await fetch('/api/player/queue');
          const qData = await qRes.json();
          setLiveQueue(qData.queue || []);
        } catch (e) {}
      }
    } catch (e) {}
  };

  const fetchSongs = async () => {
    try {
      const res = await fetch('/api/player/playlist');
      if (res.ok) {
        const d = await res.json();
        setAllSongs(d.canciones || []);
      }
    } catch (e) { console.error('Error songs:', e); }
  };

  useEffect(() => { 
    fetchNoticias(); 
    fetchFunas();
    fetchConfesiones();
    fetchStatus();
    fetchChat();
    fetchNominaciones();
    fetchSongs();
    fetchPymes();
    const interval = setInterval(() => {
      fetchFunas();
      fetchConfesiones();
      fetchStatus();
      fetchChat();
      fetchNominaciones();
      fetchPymes();
    }, 10000); 
    return () => clearInterval(interval);
  }, []);

  // Auto-scroll removido por petición del usuario para mejorar la experiencia

  const fetchFunas = async () => {
    try {
      const res = await fetch('/api/funas/list');
      const data = await res.json();
      setFunas(data);
    } catch (e) { console.error('Error funas:', e); }
  };

  const fetchPymes = async () => {
    try {
      const res = await fetch('/api/pymes/list');
      if (res.ok) {
        const data = await res.json();
        setPymes(data);
      }
    } catch (e) { console.error('Error pymes:', e); }
  };

  const fetchPymesAdmin = async () => {
    try {
      const res = await fetch('/api/pymes/admin/list');
      if (res.ok) {
        const data = await res.json();
        setPymesAdmin(data);
      }
    } catch (e) { console.error('Error pymesAdmin:', e); }
  };

  const fetchChat = async () => {
    try {
      const res = await fetch('/api/chat/');
      if (res.ok) {
        const data = await res.json();
        setChatMessages(data);
      }
    } catch (e) {}
  };

  useEffect(() => {
    if (view === 'admin' && isLoggedIn) {
      const fetchStats = async () => {
        try {
          const res = await fetch('/api/stats/pending');
          const data = await res.json();
          setAdminStats(data);
        } catch (e) { console.error('Error stats:', e); }
      };
      fetchStats();
      const int = setInterval(fetchStats, 10000);
      return () => clearInterval(int);
    }
  }, [view, isLoggedIn]);

  const handleSendChat = async (e) => {
    if (e) e.preventDefault();
    if (!chatForm.mensaje.trim()) return;
    setIsChatLoading(true);
    try {
      const res = await fetch('/api/chat/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(chatForm)
      });
      if (res.ok) {
        setChatForm(prev => ({ ...prev, mensaje: '' }));
        await fetchChat();
      }
    } catch (e) {}
    setIsChatLoading(false);
  };

  const handleDeleteChatMessage = async (id) => {
    if (!window.confirm('¿Eliminar este mensaje?')) return;
    try {
      const res = await fetch('/api/chat/' + id, { method: 'DELETE' });
      if (res.ok) {
        await fetchChat();
      }
    } catch (e) {}
  };
  
  const fetchNominaciones = async () => {
    try {
      const res = await fetch('/api/enfermero/nominaciones');
      if (res.ok) setNominaciones(await res.json());
    } catch (e) {}
  };

  const handleNominar = async (e) => {
    if (e) e.preventDefault();
    if (!nombreNominado.trim()) return;
    setIsNominating(true);
    try {
      const res = await fetch('/api/enfermero/nominar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre: nombreNominado })
      });
      if (res.ok) {
        setNombreNominado('');
        await fetchNominaciones();
        alert('¡Nominación recibida!');
      }
    } catch (e) {}
    setIsNominating(false);
  };

  const handleVotarEnfermero = async (id) => {
    const votedKey = `voted_enfermero_mayo_${id}`;
    if (localStorage.getItem(votedKey)) {
      alert('Ya has votado por este enfermero');
      return;
    }
    try {
      const res = await fetch(`/api/enfermero/votar/${id}`, { method: 'POST' });
      if (res.ok) {
        localStorage.setItem(votedKey, 'true');
        await fetchNominaciones();
      }
    } catch (e) {}
  };

  const handleDeleteNominacion = async (id) => {
    if (!window.confirm('¿Eliminar esta postulación?')) return;
    try {
      const res = await fetch('/api/enfermero/borrar/' + id, { method: 'DELETE' });
      if (res.ok) {
        await fetchNominaciones();
      }
    } catch (e) {}
  };

  const handleUpdateVotos = async (id, currentVotos) => {
    const newVotos = window.prompt('Actualizar cantidad de votos:', currentVotos);
    if (newVotos === null || newVotos === '') return;
    
    try {
      const res = await fetch('/api/enfermero/votos/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ votos: parseInt(newVotos) })
      });
      if (res.ok) {
        await fetchNominaciones();
      }
    } catch (e) {}
  };





  useEffect(() => {
    if (noticias.length > 1 && !pausarNoticias) {
      const interval = setInterval(() => setActiveNewsIndex(i => (i + 1) % noticias.length), 8000); // 8 segundos para leer mejor
      return () => clearInterval(interval);
    }
  }, [noticias, pausarNoticias]);

  useEffect(() => {
    const interval = setInterval(fetchBatallaActiva, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchNoticias = async () => {
    try {
      const res = await fetch('/api/noticias/list');
      if (res.ok) setNoticias(await res.json());
    } catch (e) {}
  };



  const fetchConfesiones = async () => {
    try {
      const res = await fetch('/api/confesiones/list');
      if (res.ok) setConfesiones(await res.json());
    } catch (e) {}
  };

  const handleCreateConfesion = async () => {
    if (!confesionForm.contenido || confesionForm.contenido.length < 10) { 
      alert('La confesión debe tener al menos 10 caracteres'); 
      return; 
    }
    setEnviandoConfesion(true);
    const formData = new FormData();
    formData.append('contenido', confesionForm.contenido);
    formData.append('pseudonimo', confesionForm.pseudonimo || 'Anónimo');
    try {
      const res = await fetch('/api/confesiones/send', { method: 'POST', body: formData });
      if (res.ok) {
        setConfesionForm({ contenido: '', pseudonimo: '' });
        setMostrandoConfesionForm(false);
        alert('Confesión enviada. Aparecerá cuando sea aprobada por el admin.');
      }
    } catch (e) { alert('Error al enviar'); }
    setEnviandoConfesion(false);
  };

  const handleCreateFuna = async () => {
    if (!funaForm.foto || !funaForm.zona) { alert('Foto y zona son obligatorias'); return; }
    setEnviandoFuna(true);
    const formData = new FormData();
    formData.append('file', funaForm.foto);
    formData.append('zona', funaForm.zona);
    formData.append('comentario', funaForm.comentario);
    try {
      const res = await fetch('/api/funas/upload', { method: 'POST', body: formData });
      if (res.ok) {
        setFunaForm({ zona: 'Frente a Pabellón', comentario: '', foto: null });
        setMostrandoFunaForm(false);
        await fetchFunas();
        alert('Reporte enviado. Se borrará automáticamente en 4 horas.');
      }
    } catch (e) { alert('Error al enviar'); }
    setEnviandoFuna(false);
  };

  const fetchBatallaActiva = async () => {
    try {
      const res = await fetch('/api/battles/active');
      if (res.ok) { const d = await res.json(); if (!d.error) setBatallaActiva(d); else setBatallaActiva(null); }
    } catch (e) {}
  };


  const loadAdminData = async () => {
    fetchBatallaActiva();
    fetchPymesAdmin();
    try {
      const [songsRes, playlistsRes, solicitudesRes, statsRes, confsRes, historyRes] = await Promise.all([
        fetch('/api/player/playlist'),
        fetch('/api/playlists/list'),
        fetch('/api/requests/pending'),
        fetch('/api/requests/statistics'),
        fetch('/api/confesiones/admin/list?status=pendiente'),
        fetch('/api/battles/history')
      ]);
      fetchSongs();
      if (playlistsRes.ok) { const d = await playlistsRes.json(); setPlaylists(d.playlists || []); }
      if (solicitudesRes.ok) { const d = await solicitudesRes.json(); setSolicitudes(d.pendientes || []); }
      if (statsRes.ok) setStatsSolicitudes(await statsRes.json());
      if (confsRes.ok) setConfesionesPendientes(await confsRes.json());
      if (historyRes.ok) setBattleHistory(await historyRes.json());
    } catch (e) {}
  };

  const loadPlaylistSongs = async (id) => {
    try {
      const res = await fetch('/api/playlists/' + id);
      if (res.ok) { const d = await res.json(); setPlaylistSongs(d.canciones || []); }
    } catch (e) {}
  };

  const handleAddSongsToPlaylist = async () => {
    if (!selectedPlaylist || selectedSongsToAdd.length === 0) return;
    setIsLoading(true);
    try {
      const res = await fetch('/api/playlists/' + selectedPlaylist + '/add-song', {
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cancion_ids: selectedSongsToAdd })
      });
      if (res.ok) {
        setSelectedSongsToAdd([]);
        await loadPlaylistSongs(selectedPlaylist);
        await loadAdminData();
        alert('Canciones agregadas');
      }
    } catch (e) { alert('Error: ' + e.message); }
    setIsLoading(false);
  };

  const handleActivatePlaylist = async (id) => {
    try {
      const res = await fetch('/api/playlists/' + id + '/play');
      if (res.ok) { 
        const d = await res.json(); 
        setPlaylistParaReproducir(d.canciones || []); 
        setPlaylistActivaId(id);
        setIndexActual(0); 
        alert('Cargada: ' + d.playlist + '. Lista para sonar.'); 
      }
    } catch (e) { alert('Error: ' + e.message); }
  };

  const handleCreateNews = async () => {
    if (!newsForm.titulo || !newsForm.contenido) { alert('Titulo y contenido requeridos'); return; }
    try {
      const res = await fetch('/api/noticias/create', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(newsForm) });
      if (res.ok) { setNewsForm({ titulo: '', contenido: '', documento_url: '' }); await fetchNoticias(); alert('Noticia creada'); }
    } catch (e) { alert('Error: ' + e.message); }
  };

  const handleDocUpload = async (file) => {
    if (!file) return;
    setUploadingDoc(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch('/api/noticias/upload', { method: 'POST', body: formData });
      if (res.ok) { const d = await res.json(); setNewsForm(prev => ({ ...prev, documento_url: d.url })); }
    } catch (e) {}
    setUploadingDoc(false);
  };

  const handleSongUpload = async (file) => {
    if (!file) return;
    setUploadingSong(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch('/api/player/upload-song', { method: 'POST', body: formData });
      if (res.ok) { 
        alert('Canción subida correctamente'); 
        await loadAdminData(); 
      } else {
        alert('Error al subir canción');
      }
    } catch (e) { alert('Error: ' + e.message); }
    setUploadingSong(false);
  };

  const handlePushToRadio = async (songId) => {
    try {
      const res = await fetch('/api/player/push/' + songId, { method: 'POST' });
      const d = await res.json();
      if (d.status === 'ok') alert('Enviado al aire con éxito');
      else alert('Error: ' + d.error);
    } catch (e) { alert('Error de conexión'); }
  };

  const handleCreateBatalla = async () => {
    if (!nuevaBatalla.nombre || !nuevaBatalla.cancion_a_id || !nuevaBatalla.cancion_b_id) { alert('Completa todos los campos'); return; }
    try {
      const res = await fetch('/api/battles/create', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ nombre: nuevaBatalla.nombre, cancion_a_id: parseInt(nuevaBatalla.cancion_a_id), cancion_b_id: parseInt(nuevaBatalla.cancion_b_id), duracion_minutos: parseInt(nuevaBatalla.duracion_minutos) }) });
      const d = await res.json();
      if (d.id) { alert('Batalla lanzada: ' + d.nombre); setNuevaBatalla({ nombre: '', cancion_a_id: '', cancion_b_id: '', duracion_minutos: 15 }); fetchBatallaActiva(); }
    } catch (e) { alert('Error: ' + e.message); }
  };

  const handleDeleteSong = async (id) => {
    if (!window.confirm('¿Eliminar esta canción permanentemente? Se borrará de todas las playlists y del disco.')) return;
    try {
      const res = await fetch('/api/player/song/' + id, { method: 'DELETE' });
      if (res.ok) {
        alert('Canción eliminada');
        await loadAdminData();
      } else {
        alert('Error al eliminar');
      }
    } catch (e) { alert('Error: ' + e.message); }
  };

  const handleUpdateSong = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await fetch('/api/player/song/' + editingSong.id, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          titulo: editingSong.titulo, 
          artista: editingSong.artista,
          duracion: editingSong.duracion
        })
      });
      if (res.ok) {
        setIsEditModalOpen(false);
        setEditingSong(null);
        await loadAdminData();
        alert('Canción actualizada correctamente');
      } else {
        alert('Error al actualizar canción');
      }
    } catch (e) { alert('Error: ' + e.message); }
    setIsLoading(false);
  };

  const handleCreatePymeAdmin = async () => {
    if (!pymeForm.nombre_pyme || !pymeForm.telefono || !pymeForm.file) {
      alert('Nombre, teléfono e imagen son obligatorios');
      return;
    }
    setIsUploadingPyme(true);
    const formData = new FormData();
    formData.append('nombre_pyme', pymeForm.nombre_pyme);
    formData.append('descripcion', pymeForm.descripcion);
    formData.append('oferta', pymeForm.oferta);
    formData.append('telefono', pymeForm.telefono);
    formData.append('file', pymeForm.file);
    try {
      const res = await fetch('/api/pymes/upload', { method: 'POST', body: formData });
      if (res.ok) {
        setPymeForm({ nombre_pyme: '', descripcion: '', oferta: '', telefono: '', file: null });
        await fetchPymes();
        alert('Pyme agregada exitosamente');
      }
    } catch (e) { alert('Error al subir'); }
    setIsUploadingPyme(false);
  };

  const handleDeletePymeAdmin = async (id) => {
    if (!window.confirm('¿Eliminar esta pyme?')) return;
    try {
      const res = await fetch(`/api/pymes/${id}`, { method: 'DELETE' });
      if (res.ok) {
        await fetchPymes();
        await fetchPymesAdmin();
        alert('Pyme eliminada');
      }
    } catch (e) { alert('Error al eliminar'); }
  };

  const handleBulkDeletePymes = async () => {
    if (selectedPymes.length === 0) return;
    if (!window.confirm(`¿Eliminar permanentemente ${selectedPymes.length} pautas seleccionadas? Esta acción no se puede deshacer.`)) return;
    try {
      const res = await fetch('/api/pymes/bulk', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids: selectedPymes })
      });
      if (res.ok) {
        setPymesAdmin(prev => prev.filter(p => !selectedPymes.includes(p.id)));
        setPymes(prev => prev.filter(p => !selectedPymes.includes(p.id)));
        setSelectedPymes([]);
      }
    } catch (e) { alert('Error al eliminar en lote'); }
  };


  const isImage = (url) => url && /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
  const handleLogin = async () => {
    if (!username.trim() || !password) return;
    setIsLoading(true);
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password })
      });
      if (!response.ok) {
        alert('Usuario o contraseña incorrectos');
        return;
      }
      setPassword('');
      setIsLoggedIn(true);
      await loadAdminData();
    } catch (error) {
      alert('No fue posible conectar con el acceso administrativo');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await fetch('/api/auth/logout', { method: 'POST' });
    } catch (error) {}
    setIsLoggedIn(false);
    setView('listener');
  };

  if (view === 'admin' && !isLoggedIn) {
    return (
      <div className="admin-login-shell">
        <div className="admin-login-card">
          <div className="text-center mb-6">
            <Music className="text-blue-400 w-12 h-12 mx-auto mb-3" />
            <h1 className="text-2xl font-bold text-white">Radio ASENF</h1>
            <p className="text-gray-400 text-sm">Acceso Administrativo</p>
          </div>
          <div className="space-y-4">
            <input 
              type="text" 
              placeholder="Nombre de usuario" 
              value={username}
              onChange={(e) => setUsername(e.target.value)} 
              className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600 focus:border-blue-400 outline-none" 
            />
            <input 
              type="password" 
              placeholder="Contraseña de administrador" 
              value={password}
              onChange={(e) => setPassword(e.target.value)} 
              onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
              className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600 focus:border-blue-400 outline-none" 
            />
            <button 
              onClick={handleLogin}
              disabled={isLoading}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white py-3 rounded-lg font-bold transition-colors"
            >
              {isLoading ? 'Verificando…' : 'Ingresar'}
            </button>
          </div>
          <button onClick={() => setView('listener')} className="w-full mt-3 text-gray-400 hover:text-white text-sm">Volver a Radio</button>
        </div>
      </div>
    );
  }

  return (
    <div className="radio-app">
      {/* HEADER */}
      <header className="radio-header">
        <div className="radio-header__inner">
          <div className="brand-lockup">
            <span className="brand-lockup__mark"><Music aria-hidden="true" /></span>
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-white leading-tight">🎵 RADIO ASENF</h1>
              <p className="text-[10px] text-blue-300">La voz de los enfermeros chilenos</p>
            </div>
          </div>
          <div className="radio-header__actions">
            {batallaActiva && <span className="animate-pulse bg-red-600 text-white text-xs px-3 py-1 rounded-full font-bold hidden md:block">⚡ BATALLA EN VIVO</span>}
            {view === 'listener' ? (
              <div className="listener-header-status">
                <div className="listener-header-status__audience">
                  <p className="text-[10px] font-black text-blue-400 uppercase tracking-widest">En el aire</p>
                  <div className="flex items-center justify-end gap-1.5">
                    <Users className="w-3 h-3 text-blue-500" />
                    <span className="text-sm font-black text-white">{oyentes}</span>
                    <span className="text-[10px] text-gray-500 font-bold">OYENTES</span>
                  </div>
                </div>
                <div className="listener-header-status__place">
                  <p className="text-sm text-gray-300">Hospital Provincial de Ovalle</p>
                  <p className="text-xs text-green-400 flex items-center justify-end gap-1">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></span> ✓ Conectado
                  </p>
                </div>
                <button onClick={() => setView('admin')} className="header-button" aria-label="Acceso administrativo">
                  <Settings className="w-4 h-4" /> Admin
                </button>
              </div>
            ) : (
              <div className="radio-header__admin-actions">
                <button onClick={() => setView('listener')} className="header-button">
                  <Music className="w-4 h-4" /> Radio
                </button>
                <button onClick={handleLogout} className="header-button header-button--danger">
                  <LogOut className="w-4 h-4" /> Salir
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* VISTA OYENTE */}
      {/* VISTA OYENTE (3 COLUMNAS) */}
      {view === 'listener' && (
        <main className="listener-shell">
          <section className="listener-intro" aria-labelledby="listener-intro-title">
            <div>
              <p className="listener-intro__eyebrow"><span aria-hidden="true" /> En directo desde Ovalle</p>
              <h2 id="listener-intro-title">Tu radio, tu turno, <em>tu comunidad.</em></h2>
              <p className="listener-intro__copy">Música, información y conversación para quienes cuidan todos los días.</p>
            </div>
            <div className="listener-intro__summary">
              <strong>{oyentes}</strong>
              <span>personas escuchando ahora</span>
            </div>
          </section>

          <div className="service-notice" role="status">
            <span className="service-notice__icon" aria-hidden="true">✓</span>
            <div><strong>Nueva señal inteligente</strong><span>Si tu conexión cambia, el audio se recupera automáticamente.</span></div>
          </div>
          
          {/* MARQUESINA DE AVISO: ACTUALIZACIONES */}
          <div className="legacy-update-marquee bg-red-600/20 backdrop-blur-sm border border-red-500/30 rounded-2xl py-3 mb-8 overflow-hidden shadow-lg">
            <div className="animate-marquee inline-block whitespace-nowrap">
              <span className="text-white font-black text-[13px] uppercase tracking-widest px-8">
                ⚠️ Dado que estamos en actualizaciones constantes la radio tiene algunas interrupciones o saltos por lo cual solo debes actualizarla y retornaremos, seguimos trabajando para ustedes
              </span>
              <span className="text-white font-black text-[13px] uppercase tracking-widest px-8">
                ⚠️ Dado que estamos en actualizaciones constantes la radio tiene algunas interrupciones o saltos por lo cual solo debes actualizarla y retornaremos, seguimos trabajando para ustedes
              </span>
            </div>
          </div>
          <div className="listener-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 items-start">
            
            <aside className="listener-sidebar lg:col-span-1 md:col-span-1 static lg:sticky top-8 space-y-8 w-full max-w-full">
              <Player />
              
              {/* SECCIÓN CHAT EN VIVO: MASCARA TELEFONO */}
              <div className="community-chat flex flex-col items-center w-full">
                <div className="phone-mockup">
                  <div className="phone-speaker"></div>
                  <div className="phone-screen">
                    {/* Header Chat */}
                    <div className="phone-chat__header bg-[#075e54] p-4 flex flex-col gap-2 shadow-md relative overflow-hidden">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                          <MessageSquare className="w-4 h-4 text-white" />
                        </div>
                        <div>
                          <h4 className="text-white text-xs font-bold leading-none">Chat en Vivo ASENF</h4>
                          <p className="text-[#25d366] text-[10px] font-medium mt-1 animate-pulse">● en directo</p>
                        </div>
                      </div>
                      
                      {/* Marquesina */}
                      <div className="phone-chat__marquee bg-black/20 -mx-4 py-1 overflow-hidden">
                        <div className="animate-marquee text-white/90 text-[9px] font-bold uppercase tracking-wider">
                          ¡Pide aquí tu música o envía tu saludo o idea! Te leemos en vivo... • ¡Pide aquí tu música o envía tu saludo o idea! Te leemos en vivo...
                        </div>
                      </div>
                    </div>

                    {/* Mensajes */}
                    <div className="live-chat-bg custom-scrollbar relative">
                      {chatMessages.map((m, i) => (



                        <div key={m.id} className={`chat-bubble ${m.autor.includes('Usuario') ? 'other' : 'mine'}`}>
                          <p className="chat-author">{m.autor}</p>
                          <p className="text-slate-800">{m.mensaje}</p>
                          <p className="chat-time">
                            {new Date(m.fecha).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Santiago' })}
                          </p>
                        </div>
                      ))}
                      <div ref={chatEndRef} />
                    </div>

                    {/* Input */}
                    <div className="phone-chat__composer bg-[#f0f2f5] p-2 border-t border-slate-300">
                      <div className="flex flex-col gap-1.5 px-2 mb-2">
                        <input 
                          type="text" 
                          placeholder="Tu nombre (opcional)"
                          value={chatForm.autor}
                          onChange={(e) => setChatForm({...chatForm, autor: e.target.value})}
                          className="bg-white text-[10px] border border-slate-300 rounded-lg px-2 py-1 focus:outline-none focus:ring-1 focus:ring-[#075e54]"
                        />
                      </div>
                      <form onSubmit={handleSendChat} className="flex items-center gap-2 px-2 pb-1">
                        <input 
                          type="text" 
                          placeholder="Mensaje..."
                          value={chatForm.mensaje}
                          onChange={(e) => setChatForm({...chatForm, mensaje: e.target.value})}
                          className="flex-1 bg-white text-xs border border-slate-300 rounded-full px-4 py-2 focus:outline-none focus:ring-1 focus:ring-[#075e54]"
                        />
                        <button 
                          type="submit" 
                          disabled={isChatLoading}
                          className="w-9 h-9 bg-[#075e54] hover:bg-[#054c44] text-white rounded-full flex items-center justify-center shadow-lg transition-transform active:scale-90 disabled:opacity-50"
                        >
                          <Send className="w-4 h-4" />
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
                <p className="text-gray-400 text-[9px] mt-4 uppercase tracking-widest font-black text-center opacity-50">Chat público interactivo</p>
              </div>
            </aside>


            {/* CENTRO: VIDEO Y NOTICIAS (PROTAGONISTA - 2/4) */}
            <section className="listener-main lg:col-span-2 md:col-span-2 space-y-8 w-full max-w-full">
              {noticias.length > 0 && (
                <div className="news-stage bg-slate-900 bg-opacity-60 backdrop-blur-md rounded-3xl border border-slate-800 shadow-2xl relative overflow-hidden transition-all duration-300 hover:border-blue-500 group flex flex-col h-[550px] md:h-[700px]"
                  onMouseEnter={() => setPausarNoticias(true)}
                  onMouseLeave={() => setPausarNoticias(false)}>
                  
                  {/* Overlay gradiente para profundidad */}
                  <div className="absolute inset-0 bg-gradient-to-b from-blue-600/5 via-transparent to-black/40 pointer-events-none"></div>

                  {pausarNoticias && (
                    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-20">
                      <span className="bg-blue-600 text-[10px] font-black px-3 py-1 rounded-full text-white shadow-lg border border-white/20">
                        LECTURA PAUSADA
                      </span>
                    </div>
                  )}

                  <div className="news-stage__counter absolute top-0 right-0 p-6 z-20">
                    <div className="bg-black/60 backdrop-blur-md text-blue-400 text-[10px] font-black px-4 py-1.5 rounded-full border border-blue-500/30 tracking-widest uppercase shadow-xl">
                      COMUNICADO {activeNewsIndex + 1}/{noticias.length}
                    </div>
                  </div>
                  
                  <div key={activeNewsIndex} className="news-stage__content flex-1 flex flex-col p-6 md:p-12 overflow-hidden relative z-10 animate-fade-in">
                    <div className="flex-shrink-0 mb-6">
                      <h3 className="text-2xl md:text-5xl font-black text-white mb-4 tracking-tighter leading-tight bg-gradient-to-br from-white via-white to-blue-200 bg-clip-text text-transparent drop-shadow-sm">
                        {noticias[activeNewsIndex]?.titulo}
                      </h3>
                      <div className="h-1.5 w-24 bg-blue-600 rounded-full shadow-lg shadow-blue-500/50"></div>
                    </div>

                    <div className="news-stage__copy flex-1 overflow-y-auto custom-scrollbar pr-2 mb-8 group-hover:pr-1 transition-all">
                      <p className="text-gray-300 text-lg md:text-2xl leading-relaxed font-medium">
                        {noticias[activeNewsIndex]?.contenido}
                      </p>
                    </div>

                    {noticias[activeNewsIndex]?.documento_url && (
                      <div className="flex-shrink-0 mt-auto pt-4 border-t border-slate-800/50">
                        {isImage(noticias[activeNewsIndex].documento_url) ? (
                          <div className="rounded-2xl overflow-hidden border border-slate-700/50 shadow-2xl aspect-video bg-black/40 flex items-center justify-center group-hover:border-blue-500/50 transition-all duration-500">
                            <img src={noticias[activeNewsIndex].documento_url} alt="Comunicado" className="w-full h-full object-contain hover:scale-105 transition-transform duration-700" />
                          </div>
                        ) : (
                          <div className="flex justify-center py-2">
                            <a href={noticias[activeNewsIndex].documento_url} target="_blank" rel="noopener noreferrer" 
                              className="inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-500 text-white px-10 py-4 rounded-2xl font-black transition-all shadow-xl shadow-blue-900/40 text-lg hover:scale-105 active:scale-95">
                              <Newspaper className="w-6 h-6" /> VER DOCUMENTO OFICIAL
                            </a>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Indicadores de paginación con estilo premium */}
                  {noticias.length > 1 && (
                    <div className="flex justify-center gap-2 md:gap-3 p-8 pt-0 relative z-20">
                      {noticias.map((_, i) => (
                        <button key={i} onClick={() => setActiveNewsIndex(i)}
                          className={`h-2 rounded-full transition-all duration-700 ${i === activeNewsIndex ? 'w-12 md:w-20 bg-blue-500 shadow-[0_0_15px_rgba(59,130,246,0.5)]' : 'w-2 md:w-3 bg-slate-800 hover:bg-slate-700'}`} />
                      ))}
                    </div>
                  )}
                </div>
              )}
              
              {/* Fallback si no hay noticias */}
              {noticias.length === 0 && (
                <div className="news-stage news-stage--empty bg-slate-900 bg-opacity-40 rounded-3xl border border-slate-800 border-dashed text-center flex flex-col items-center justify-center h-[550px] md:h-[700px] p-10">
                  <div className="bg-slate-800/50 p-8 rounded-full mb-6">
                    <Newspaper className="w-16 h-16 text-slate-600 opacity-50" />
                  </div>
                  <p className="text-slate-500 font-bold text-2xl uppercase tracking-widest max-w-xs">Esperando boletín informativo...</p>
                  <p className="text-slate-600 text-sm mt-4">Las noticias y comunicados aparecerán aquí automáticamente.</p>
                </div>
              )}

              {/* SECCIÓN PYMES: PAUTA AQUÍ TU PYME — DISEÑO BILLBOARD */}
              {pymes.length > 0 && (
              <div className="w-full">
                {/* Header minimalista */}
                <div className="flex items-center justify-between mb-4 px-1">
                  <div className="flex items-center gap-2">
                    <Store size={16} className="text-blue-400" />
                    <span className="text-white font-black text-sm uppercase tracking-widest">Pauta tu Pyme</span>
                    <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse"></span>
                  </div>
                  <span className="text-blue-400/50 text-[9px] font-black uppercase tracking-widest">Emprendimiento local</span>
                </div>

                {/* Cards billboard */}
                <div className={`grid gap-4 ${pymes.length === 1 ? 'grid-cols-1' : pymes.length === 2 ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1 sm:grid-cols-2'}`}>
                  {pymes.map((pyme, idx) => (
                    <div key={pyme.id}
                      className="pyme-card relative rounded-3xl overflow-hidden group cursor-pointer"
                      style={{minHeight: pymes.length === 1 ? '340px' : '280px'}}>

                      {/* Imagen fondo a full */}
                      <img
                        src={getFullUrl(pyme.imagen_url)}
                        alt={pyme.nombre_pyme}
                        className="pyme-card__image absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />

                      {/* Gradiente overlay */}
                      <div className="pyme-card__shade pyme-card__shade--vertical absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
                      <div className="pyme-card__shade pyme-card__shade--horizontal absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>

                      {/* Badge oferta */}
                      {pyme.oferta && (
                        <div className="pyme-card__offer absolute top-4 right-4 z-10">
                          <div className="bg-yellow-400 text-slate-900 text-[10px] font-black px-3 py-1.5 rounded-full shadow-lg shadow-yellow-400/30 flex items-center gap-1">
                            <span>🎯</span> OFERTA
                          </div>
                        </div>
                      )}

                      {/* Badge número de pauta */}
                      <div className="pyme-card__slot absolute top-4 left-4 z-10">
                        <div className="bg-blue-600/80 backdrop-blur-sm text-white text-[9px] font-black px-2.5 py-1 rounded-full border border-blue-400/30">
                          PAUTA #{idx + 1}
                        </div>
                      </div>

                      {/* Contenido inferior */}
                      <div className="pyme-card__content absolute bottom-0 left-0 right-0 p-5 z-10">
                        <h4 className="text-white font-black text-xl leading-tight mb-1 drop-shadow-lg">
                          {pyme.nombre_pyme}
                        </h4>

                        {pyme.descripcion && (
                          <p className="text-white/70 text-xs leading-relaxed mb-3 line-clamp-2">
                            {pyme.descripcion}
                          </p>
                        )}

                        {pyme.oferta && (
                          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-3 py-1.5 mb-3">
                            <span className="text-yellow-300 text-[10px] font-black uppercase">Promoción:</span>
                            <span className="text-white text-[10px] font-bold">{pyme.oferta}</span>
                          </div>
                        )}

                        <div className="flex items-center justify-between gap-3">
                          <div className="flex items-center gap-2">
                            <Phone size={13} className="text-blue-400" />
                            <span className="text-white/80 text-xs font-bold">{pyme.telefono}</span>
                          </div>
                          <a
                            href={pyme.whatsapp_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            className="flex items-center gap-2 bg-[#25d366] hover:bg-[#128c7e] text-white px-4 py-2 rounded-full shadow-lg shadow-green-900/40 transition-all hover:scale-105 active:scale-95 font-black text-xs"
                          >
                            <MessageCircle size={14} fill="currentColor" />
                            CONTACTAR
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              )}

              {/* SECCIÓN CONFESIONES (RESTAURADA) */}
              <div className="confessions-card bg-[#efeae2] rounded-3xl border border-slate-300 shadow-2xl relative overflow-hidden transition-all duration-300 flex flex-col min-h-[400px] h-[50vh] md:h-[500px]">
                {/* Header WhatsApp Style */}
                <div className="confessions-card__header bg-[#008069] p-4 flex items-center justify-between shadow-md z-10">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-inner">
                      <Heart className="w-6 h-6 fill-white" />
                    </div>
                    <div>
                      <h3 className="text-white font-bold leading-tight">Confesiones ASENF</h3>
                      <p className="text-[#d1f4e6] text-xs">en línea</p>
                    </div>
                  </div>
                  <button onClick={() => setMostrandoConfesionForm(!mostrandoConfesionForm)}
                    className={`${mostrandoConfesionForm ? 'bg-red-500' : 'bg-yellow-400 text-teal-900 animate-pulse'} hover:scale-105 transition-all px-5 py-2 rounded-full font-black text-[10px] uppercase shadow-lg border-2 border-white/30`}>
                    {mostrandoConfesionForm ? 'CERRAR' : '✍️ ESCRIBIR'}
                  </button>
                </div>

                {/* Chat Area */}
                <div className="confessions-card__feed flex-1 whatsapp-bg overflow-y-auto p-4 md:p-6 flex flex-col gap-4 custom-scrollbar">
                  {mostrandoConfesionForm && (
                    <div className="bg-[#f0f2f5] p-6 rounded-2xl border border-slate-300 mb-4 animate-in zoom-in-95 duration-200">
                      <div className="space-y-4">
                        <textarea 
                          placeholder="Escribe tu confesión aquí..."
                          value={confesionForm.contenido}
                          onChange={(e) => setConfesionForm({...confesionForm, contenido: e.target.value})}
                          className="w-full bg-white text-gray-800 border border-slate-300 rounded-xl px-4 py-3 h-24 focus:outline-none focus:ring-2 focus:ring-[#008069] transition-all resize-none"
                        />
                        <div className="flex gap-2">
                          <input 
                            type="text" 
                            placeholder="Pseudónimo (opcional)"
                            value={confesionForm.pseudonimo}
                            onChange={(e) => setConfesionForm({...confesionForm, pseudonimo: e.target.value})}
                            className="flex-1 bg-white text-gray-800 border border-slate-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#008069]"
                          />
                          <button onClick={handleCreateConfesion} disabled={enviandoConfesion}
                            className="bg-[#008069] hover:bg-[#005e4b] text-white px-6 rounded-xl font-bold transition disabled:opacity-50">
                            {enviandoConfesion ? '...' : <Send className="w-5 h-5" />}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {confesiones.map(c => (
                    <div key={c.id} className="wa-bubble received">
                      <div className="wa-bubble-tail"></div>
                      <p className="text-[#e911d1] font-bold text-[13px] mb-0.5">{c.pseudonimo || 'Anónimo'}</p>
                      <p className="text-[#111b21]">{c.contenido}</p>
                      <span className="wa-time">
                        {new Date(c.fecha_envio).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Santiago' })}
                      </span>
                    </div>
                  ))}

                  {confesiones.length === 0 && !mostrandoConfesionForm && (
                    <div className="mt-20 text-center text-gray-500 bg-white/80 p-6 rounded-2xl mx-auto max-w-xs shadow-sm">
                      <p className="font-bold text-sm">No hay mensajes aún</p>
                      <p className="text-xs">Las confesiones aprobadas aparecerán aquí como chats.</p>
                    </div>
                  )}
                </div>

                {/* Footer Input placeholder */}
                <div className="confessions-card__composer bg-[#f0f2f5] p-3 flex items-center gap-3">
                  <div className="bg-white flex-1 rounded-full px-4 py-2 text-gray-400 text-sm border border-slate-200 cursor-pointer" onClick={() => setMostrandoConfesionForm(true)}>
                    Escribe una confesión...
                  </div>
                  <div className="w-10 h-10 bg-[#008069] rounded-full flex items-center justify-center text-white">
                    <Send className="w-5 h-5" />
                  </div>
                </div>
              </div>





              {/* SECCIÓN FUNA: EL AUTO QUE TE TAPA */}
                <div className="bg-slate-900 bg-opacity-60 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-slate-800 shadow-2xl w-full">
                  <div className="flex items-center justify-between mb-6">
                    <div>
                      <h3 className="text-2xl font-black text-white flex items-center gap-2">
                        <span className="text-red-500">🚫</span> FUNA: AUTO MAL ESTACIONADO
                      </h3>
                      <p className="text-gray-400 text-sm">¿Te taparon el paso? Repórtalo aquí. (Expira en 4h)</p>
                    </div>
                    <button onClick={() => setMostrandoFunaForm(!mostrandoFunaForm)}
                      className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-xl font-bold text-sm transition">
                      {mostrandoFunaForm ? 'CANCELAR' : 'REPORTAR AUTO'}
                    </button>
                  </div>

                  {mostrandoFunaForm && (
                    <div className="bg-slate-800 bg-opacity-50 p-6 rounded-2xl border border-slate-700 mb-8 animate-in fade-in slide-in-from-top-4">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">¿Dónde está?</label>
                          <select value={funaForm.zona} onChange={(e) => setFunaForm({...funaForm, zona: e.target.value})}
                            className="w-full bg-slate-700 text-white border border-slate-600 rounded-xl px-4 py-3 focus:outline-none focus:border-red-500">
                            <option>Frente a Pabellón</option>
                            <option>Hospitalización</option>
                            <option>Detrás de Vestidores</option>
                            <option>Urgencia</option>
                            <option>Estacionamiento de Tierra</option>
                            <option>Otro</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">Evidencia (Foto)</label>
                          <input type="file" accept="image/*" onChange={(e) => setFunaForm({...funaForm, foto: e.target.files[0]})}
                            className="w-full text-sm text-gray-400 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-700 file:text-white hover:file:bg-slate-600" />
                        </div>
                      </div>
                      <div className="mb-4">
                        <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">Detalles (Opcional)</label>
                        <input type="text" placeholder="Ej: Auto blanco patente ABCD-12" value={funaForm.comentario} onChange={(e) => setFunaForm({...funaForm, comentario: e.target.value})}
                          className="w-full bg-slate-700 text-white border border-slate-600 rounded-xl px-4 py-3 focus:outline-none focus:border-red-500" />
                      </div>
                      <button onClick={handleCreateFuna} disabled={enviandoFuna}
                        className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-black transition disabled:opacity-50">
                        {enviandoFuna ? 'SUBIENDO...' : 'PUBLICAR REPORTE'}
                      </button>
                    </div>
                  )}

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {funas.map(f => (
                      <div key={f.id} className="bg-slate-800 bg-opacity-40 rounded-2xl border border-slate-700 overflow-hidden group">
                        <div className="relative aspect-video">
                          <img src={getFullUrl(f.foto_url)} alt="Funa" className="w-full h-full object-cover" />
                          <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-[10px] text-white px-2 py-1 rounded-full font-bold">
                            EXPIRA: {f.expira_en.split(' ')[1]}
                          </div>
                        </div>
                        <div className="p-4">
                          <div className="flex items-center gap-2 mb-2">
                            <span className="bg-red-900 text-red-200 text-[10px] px-2 py-0.5 rounded font-bold uppercase">{f.zona}</span>
                            <span className="text-[10px] text-gray-500">{f.creado_en.split(' ')[1]}</span>
                          </div>
                          <p className="text-sm text-gray-300 font-medium">{f.comentario || 'Sin descripción'}</p>
                        </div>
                      </div>
                    ))}
                    {funas.length === 0 && !mostrandoFunaForm && (
                      <div className="col-span-full py-10 text-center text-slate-600">
                        <p className="text-4xl mb-2">🚗✨</p>
                        <p className="font-bold uppercase tracking-widest text-sm">Todo despejado. No hay autos tapando.</p>
                      </div>
                    )}
                  </div>
                </div>
            </section>

              {/* DERECHA: BATALLAS Y ENFERMERO DEL MES (1/4) */}
            <aside className="listener-rail lg:col-span-1 md:col-span-2 lg:static lg:sticky top-8 space-y-8 w-full max-w-full">
              <Battle />
              
              {/* IMAGEN ENFERMERO DEL MES */}
              <div className="nurse-highlight rounded-3xl overflow-hidden shadow-2xl border border-blue-500/30">
                <img src="/enfermero-mayo.png" alt="Enfermero de Mayo" className="w-full h-auto object-cover" />
              </div>
            </aside>

          </div>
        </main>
      )}

      {/* VISTA ADMIN */}
      {view === 'admin' && isLoggedIn && (
        <div className="flex flex-col md:flex-row min-h-screen">
          <aside className="w-full md:w-64 bg-black bg-opacity-50 border-b md:border-b-0 md:border-r border-blue-500 p-4 md:space-y-2 h-auto md:min-h-screen backdrop-blur-md flex md:flex-col overflow-x-auto gap-2 md:gap-0 custom-scrollbar">
            {[
              { id: 'dashboard', icon: <BarChart2 className="w-4 h-4" />, label: 'Dashboard' },
              { id: 'reproductor', icon: <Play className="w-4 h-4" />, label: 'Reproductor' },
              { id: 'canciones', icon: <Music className="w-4 h-4" />, label: 'Canciones' },
              { id: 'batalla', icon: <Swords className="w-4 h-4" />, label: 'Batallas' },
              { id: 'playlists', icon: <List className="w-4 h-4" />, label: 'Playlists' },
              {id: 'noticias', icon: <Newspaper className="w-4 h-4" />, label: 'Noticias'},
              {id: 'funas', icon: <Trash2 className="w-4 h-4" />, label: 'Funas'},
              {id: 'confesiones', icon: <Heart className="w-4 h-4" />, label: 'Confesiones'},
              {id: 'chat', icon: <MessageSquare className="w-4 h-4" />, label: 'Chat'},
              {id: 'solicitudes', icon: <Music className="w-4 h-4" />, label: 'Solicitudes'},

              { id: 'enfermero_mes', icon: <Trophy className="w-4 h-4" />, label: 'Enfermero Mes' },
              { id: 'pymes', icon: <Store className="w-4 h-4" />, label: 'Pymes' },
              { id: 'configuracion', icon: <Wrench className="w-4 h-4" />, label: 'Configuracion' },

            ].map(tab => {
              let badge = null;
              if (tab.id === 'confesiones' && adminStats.confesiones > 0) badge = <span className="bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full ml-auto animate-pulse">{adminStats.confesiones}</span>;
              if (tab.id === 'solicitudes' && adminStats.solicitudes > 0) badge = <span className="bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full ml-auto animate-pulse">{adminStats.solicitudes}</span>;
              if (tab.id === 'funas' && adminStats.funas > 0) badge = <span className="bg-orange-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full ml-auto">{adminStats.funas}</span>;

              return (
                <button key={tab.id} onClick={() => { setAdminTab(tab.id); loadAdminData(); }}
                  className={'w-auto md:w-full flex-shrink-0 flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold transition ' + (adminTab === tab.id ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-slate-700 hover:text-white')}>
                  {tab.icon} <span className="flex-1 text-left">{tab.label}</span> {badge}
                </button>
              );
            })}
          </aside>

          <main className="flex-1 p-4 md:p-8 overflow-y-auto">

            {adminTab === 'dashboard' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Dashboard</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                  {[
                    { label: 'Canciones', value: allSongs.length, icon: '🎵' },
                    { label: 'Playlists', value: playlists.length, icon: '📋' },
                    { label: 'Solicitudes', value: statsSolicitudes?.pendientes || 0, icon: '📥' },
                    { label: 'Noticias', value: noticias.length, icon: '📰' },
                  ].map((s, i) => (
                    <div key={i} className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 text-center backdrop-blur-md">
                      <p className="text-4xl mb-2">{s.icon}</p>
                      <p className="text-3xl font-bold text-blue-400">{s.value}</p>
                      <p className="text-gray-400 text-sm mt-1">{s.label}</p>
                    </div>
                  ))}
                </div>
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-4">Estado de Servicios</h3>
                  <div className="space-y-3">
                    {['Icecast2 (Streaming)', 'Liquidsoap (Motor de Radio)', 'FastAPI Backend', 'Nginx'].map((s, i) => (
                      <div key={i} className="flex items-center justify-between p-3 bg-slate-800 bg-opacity-60 rounded-lg">
                        <span className="text-white text-sm">{s}</span>
                        <span className="text-xs font-bold px-3 py-1 rounded-full bg-green-900 text-green-400">✅ Activo</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {adminTab === 'canciones' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Biblioteca Musical</h2>
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 mb-6 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-4">Descargar desde YouTube</h3>
                  <div className="flex gap-4">
                    <input 
                      type="text" 
                      placeholder="Pega el link de YouTube aquí..." 
                      value={ytUrl}
                      onChange={(e) => setYtUrl(e.target.value)}
                      className="flex-1 bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600 focus:border-blue-400 outline-none" 
                    />
                    <button 
                      onClick={handleYtDownload}
                      disabled={isDownloading || !ytUrl}
                      className="bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white px-6 py-3 rounded-xl font-bold transition flex items-center gap-2"
                    >
                      {isDownloading ? (ytDownloadMsg || 'DESCARGANDO...') : 'DESCARGAR MP3'}
                    </button>
                  </div>
                  <p className="text-[10px] text-gray-500 mt-2 uppercase font-bold tracking-widest text-center">La canción se guardará directamente en la biblioteca</p>
                </div>

                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-amber-500 mb-6 backdrop-blur-md">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-white">🔐 Cookies de YouTube</h3>
                    {cookiesStatus.cookies_configuradas ? (
                      <span className="text-xs font-bold text-emerald-400 bg-emerald-900/40 px-3 py-1 rounded-full">✓ Configuradas ({Math.round(cookiesStatus.tamaño_bytes/1024)} KB)</span>
                    ) : (
                      <span className="text-xs font-bold text-amber-400 bg-amber-900/40 px-3 py-1 rounded-full">⚠ No configuradas</span>
                    )}
                  </div>
                  <p className="text-sm text-gray-300 mb-4">
                    Para descargar videos con copyright agresivo, sube tu archivo <code className="bg-slate-700 px-1 rounded">cookies.txt</code> exportado desde Chrome con la extensión <strong>"Get cookies.txt LOCALLY"</strong> en youtube.com.
                  </p>
                  <div className="flex gap-3">
                    <input
                      type="file"
                      accept=".txt"
                      onChange={(e) => handleCookiesUpload(e.target.files[0])}
                      className="hidden"
                      id="cookies-upload"
                    />
                    <label
                      htmlFor="cookies-upload"
                      className={"flex-1 cursor-pointer bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 rounded-xl font-bold transition text-center " + (uploadingCookies ? "opacity-50 cursor-wait" : "")}
                    >
                      {uploadingCookies ? "SUBIENDO..." : (cookiesStatus.cookies_configuradas ? "ACTUALIZAR COOKIES" : "SUBIR cookies.txt")}
                    </label>
                    <button onClick={fetchCookiesStatus} className="bg-slate-600 hover:bg-slate-700 text-white px-4 py-3 rounded-xl font-bold transition">↻</button>
                  </div>
                </div>

                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 mb-6 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-4">Subir Nueva Canción</h3>
                  <div className="p-8 border-2 border-dashed border-blue-500 border-opacity-30 rounded-xl text-center">
                    <Music className="w-12 h-12 text-blue-400 mx-auto mb-4 opacity-50" />
                    <p className="text-gray-300 mb-4 text-sm">Selecciona un archivo MP3 para agregar a la radio</p>
                    <input 
                      type="file" 
                      accept="audio/mpeg" 
                      onChange={(e) => handleSongUpload(e.target.files[0])}
                      className="hidden" 
                      id="song-upload" 
                    />
                    <label 
                      htmlFor="song-upload"
                      className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-xl font-bold cursor-pointer transition"
                    >
                      {uploadingSong ? 'SUBIENDO...' : 'SELECCIONAR ARCHIVO'}
                    </label>
                  </div>
                </div>
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 mb-6 backdrop-blur-md">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-white">Biblioteca Musical</h3>
                    <div className="relative w-72">
                      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                      <input 
                        type="text" 
                        placeholder="Buscar canción o artista..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full bg-slate-800 text-white pl-10 pr-4 py-2 rounded-xl border border-slate-700 focus:border-blue-500 focus:outline-none text-sm transition-all"
                      />
                    </div>
                  </div>
                  
                  {/* Indicador de canción actual al aire */}
                  <div className="mt-4 p-4 bg-green-500/10 border border-green-500/20 rounded-xl flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-ping"></div>
                      <div>
                        <p className="text-[10px] text-green-400 font-black uppercase tracking-widest">En vivo ahora</p>
                        <p className="text-white font-bold text-sm">
                          {currentSongTitle}
                        </p>

                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-[10px] text-gray-500 font-bold uppercase">Oyentes</p>
                      <p className="text-white font-black text-xl">{oyentes}</p>
                    </div>
                  </div>
                </div>


                <div className="bg-black bg-opacity-40 rounded-xl overflow-x-auto border border-blue-500 backdrop-blur-md">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="bg-blue-600 bg-opacity-20 text-blue-400 text-[10px] uppercase tracking-widest font-black">
                        <th className="px-6 py-4">Título</th>
                        <th className="px-6 py-4">Artista</th>
                        <th className="px-6 py-4">Duración</th>
                        <th className="px-6 py-4">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5">
                      {allSongs
                        .filter(s => 
                          s.titulo.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          s.artista.toLowerCase().includes(searchTerm.toLowerCase())
                        )
                        .map(s => (

                        <tr key={s.id} className="hover:bg-white/5 transition-colors group">
                          <td className="px-6 py-4">
                            <div className="flex flex-col">
                              <div className="flex items-center gap-2">
                                <p className="text-white font-bold text-sm">{s.titulo}</p>
                                {Number(s.id) === Number(currentSongId) && (
                                  <span className="bg-green-500 text-white text-[9px] font-black px-2 py-1 rounded border border-green-400 animate-pulse flex items-center gap-1 shadow-[0_0_10px_rgba(34,197,94,0.5)]">
                                    AL AIRE
                                  </span>
                                )}

                              </div>
                              <p className="text-[10px] text-gray-500">{s.genero}</p>
                            </div>
                          </td>

                          <td className="px-6 py-4 text-gray-300 text-sm">{s.artista}</td>
                          <td className="px-6 py-4 text-gray-400 text-sm">
                            {Math.floor(s.duracion / 60)}:{(s.duracion % 60).toString().padStart(2, '0')}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex gap-2">
                              <button 
                                onClick={() => handlePushToRadio(s.id)}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-wider transition"
                                title="Enviar al aire"
                              >
                                Al Aire
                              </button>
                              <button 
                                onClick={() => { setEditingSong({...s}); setIsEditModalOpen(true); }}
                                className="bg-slate-700 hover:bg-slate-600 text-white px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-wider transition border border-slate-600 flex items-center gap-1"
                                title="Editar título/artista"
                              >
                                <Pencil className="w-3 h-3" />
                                Editar
                              </button>
                              <button 
                                onClick={() => handleDeleteSong(s.id)}
                                className="bg-red-900/50 hover:bg-red-600 text-red-200 hover:text-white px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-wider transition border border-red-500/20"
                                title="Eliminar definitivamente"
                              >
                                Borrar
                              </button>
                            </div>

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {adminTab === 'reproductor' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Reproductor Admin</h2>
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 mb-6 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-4">Selecciona Playlist</h3>
                  <select className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600 mb-4"
                    value={playlistActivaId || ''}
                    onChange={(e) => { if (e.target.value) handleActivatePlaylist(parseInt(e.target.value)); }}>
                    <option value="">-- Selecciona una playlist --</option>
                     {playlists.map(pl => <option key={pl.id} value={pl.id}>{pl.nombre} ({pl.cantidad_canciones} canciones)</option>)}
                   </select>
                   <div className="grid grid-cols-2 gap-3 mb-4">
                     <button onClick={async () => {
                       if (playlistActivaId) {
                         try {
                           const res = await fetch('/api/player/start-playlist/' + playlistActivaId, { method: 'POST' });
                           const d = await res.json();
                           if (d.status === 'ok') alert('Playlist puesta al aire con éxito en la radio');
                           else alert('Error: ' + d.error);
                         } catch (e) { alert('Error de conexión'); }
                       } else {
                         alert('Selecciona una playlist del menú de arriba primero');
                       }
                     }} className="bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold flex items-center justify-center gap-2">
                       <Play className="w-5 h-5" /> PONER AL AIRE
                     </button>
                     
                     <button onClick={async () => {
                        try {
                          const res = await fetch('/api/player/stop-playlist', { method: 'POST' });
                          const d = await res.json();
                          if (d.status === 'ok') {
                            alert('Volviendo a programación automática (horarios)');
                            setPlaylistActivaId(null);
                          } else alert('Error: ' + d.error);
                        } catch (e) { alert('Error de conexión'); }
                     }} className="bg-slate-600 hover:bg-slate-700 text-white py-3 rounded-lg font-bold flex items-center justify-center gap-2">
                       <Clock className="w-5 h-5" /> AUTO (HORARIOS)
                     </button>
                   </div>
                 </div>


                {/* ── PANEL AVANZADO: SHUFFLE + COLA POR DEMANDA ── */}
                <AdminQueuePanel allSongs={allSongs} currentSongTitle={currentSongTitle} />

              </div>
            )}

            {adminTab === 'batalla' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Batallas Musicales</h2>
                {batallaActiva && (
                  <div className="bg-black bg-opacity-40 rounded-xl p-6 border-2 border-red-500 mb-6 backdrop-blur-md">
                    <div className="flex items-center justify-between mb-4">
                      <span className="text-white font-bold">ACTIVA: {batallaActiva.nombre}</span>
                      <button onClick={async () => { await fetch('/api/battles/end/' + batallaActiva.id, { method: 'POST' }); setBatallaActiva(null); }}
                        className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-bold">Terminar</button>
                    </div>
                    <div className="grid grid-cols-2 gap-4 text-center">
                      <div className="bg-orange-900 bg-opacity-50 p-4 rounded-lg">
                        <p className="text-white font-bold">{batallaActiva.cancion_a}</p>
                        <p className="text-3xl font-bold text-orange-400 mt-2">{batallaActiva.votos_a}</p>
                        <p className="text-gray-400 text-xs">votos</p>
                      </div>
                      <div className="bg-blue-900 bg-opacity-50 p-4 rounded-lg">
                        <p className="text-white font-bold">{batallaActiva.cancion_b}</p>
                        <p className="text-3xl font-bold text-blue-400 mt-2">{batallaActiva.votos_b}</p>
                        <p className="text-gray-400 text-xs">votos</p>
                      </div>
                    </div>
                  </div>
                )}
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-4">Crear Nueva Batalla</h3>
                  <div className="space-y-4">
                    <input type="text" placeholder="Nombre (ej: Rock vs Pop)" value={nuevaBatalla.nombre}
                      onChange={(e) => setNuevaBatalla({ ...nuevaBatalla, nombre: e.target.value })}
                      className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600" />
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="text-gray-400 text-xs mb-1 block">Cancion A:</label>
                        <select value={nuevaBatalla.cancion_a_id} onChange={(e) => setNuevaBatalla({ ...nuevaBatalla, cancion_a_id: e.target.value })}
                          className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600">
                          <option value="">-- Cancion A --</option>
                          {allSongs.map(s => <option key={s.id} value={s.id}>{s.titulo} - {s.artista}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="text-gray-400 text-xs mb-1 block">Cancion B:</label>
                        <select value={nuevaBatalla.cancion_b_id} onChange={(e) => setNuevaBatalla({ ...nuevaBatalla, cancion_b_id: e.target.value })}
                          className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600">
                          <option value="">-- Cancion B --</option>
                          {allSongs.map(s => <option key={s.id} value={s.id}>{s.titulo} - {s.artista}</option>)}
                        </select>
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-400 text-xs mb-1 block">Duracion (minutos):</label>
                      <input type="number" value={nuevaBatalla.duracion_minutos} min="1" max="60"
                        onChange={(e) => setNuevaBatalla({ ...nuevaBatalla, duracion_minutos: e.target.value })}
                        className="w-full bg-slate-700 text-white px-4 py-3 rounded-lg border border-slate-600" />
                    </div>
                    <button onClick={handleCreateBatalla} className="w-full bg-red-600 hover:bg-red-700 text-white py-4 rounded-lg font-bold text-lg">
                      ⚡ LANZAR BATALLA AHORA
                    </button>
                  </div>
                </div>

                <div className="mt-8">
                  <h3 className="text-lg font-bold text-white mb-4">Historial de Batallas</h3>
                  <div className="space-y-3">
                    {battleHistory.map(b => (
                      <div key={b.id} className="bg-black bg-opacity-40 p-4 rounded-xl border border-slate-700 flex justify-between items-center backdrop-blur-md">
                        <div>
                          <p className="text-white font-bold text-sm">{b.nombre}</p>
                          <p className="text-xs text-gray-400">{b.creada_en}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-blue-400 font-black text-sm">
                            {b.votos_a >= b.votos_b ? b.cancion_a : b.cancion_b}
                          </p>
                          <p className="text-[10px] text-gray-500 font-bold uppercase">GANADOR ({Math.max(b.votos_a, b.votos_b)} votos)</p>
                        </div>
                      </div>
                    ))}
                    {battleHistory.length === 0 && <p className="text-gray-500 text-center py-4">No hay historial disponible</p>}
                  </div>
                </div>
              </div>
            )}

            {adminTab === 'playlists' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Playlists</h2>
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 mb-6 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-4">Nueva Playlist</h3>
                  <div className="space-y-3">
                    <input type="text" placeholder="Nombre" value={nuevaPlaylist.nombre}
                      onChange={(e) => setNuevaPlaylist({ ...nuevaPlaylist, nombre: e.target.value })}
                      className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" />
                    <textarea placeholder="Descripcion" value={nuevaPlaylist.descripcion}
                      onChange={(e) => setNuevaPlaylist({ ...nuevaPlaylist, descripcion: e.target.value })}
                      className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" rows="2" />
                    <button onClick={async () => {
                      if (!nuevaPlaylist.nombre.trim()) { alert('Nombre requerido'); return; }
                      const res = await fetch('/api/playlists/create', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(nuevaPlaylist) });
                      const d = await res.json();
                      if (d.id) { alert('Playlist creada con éxito'); setNuevaPlaylist({ nombre: '', descripcion: '' }); loadAdminData(); }
                      else { alert(d.error || 'Error'); }
                    }} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg font-semibold">
                      Crear Playlist
                    </button>
                  </div>
                </div>
                <div className="space-y-4">
                  {playlists.map(pl => (
                    <div key={pl.id} className="bg-black bg-opacity-40 rounded-xl p-5 border border-blue-500 backdrop-blur-md">
                      <div className="flex items-center justify-between mb-3">
                        <div>
                          <p className="text-white font-bold text-lg">{pl.nombre}</p>
                          <p className="text-gray-400 text-sm">{pl.descripcion}</p>
                          <p className="text-blue-400 text-xs mt-1">{pl.cantidad_canciones} canciones - {Math.floor((pl.duracion_total || 0) / 60)}m</p>
                        </div>
                        <div className="flex gap-2">
                          <button onClick={() => { setSelectedPlaylist(selectedPlaylist === pl.id ? null : pl.id); if (selectedPlaylist !== pl.id) loadPlaylistSongs(pl.id); }}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-bold">
                            {selectedPlaylist === pl.id ? 'Cerrar' : 'Editar'}
                          </button>
                          <button onClick={async () => {
                            if (window.confirm('¿Eliminar esta playlist completa?')) {
                              await fetch('/api/playlists/' + pl.id, { method: 'DELETE' });
                              loadAdminData();
                            }
                          }}
                            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-bold">
                            Borrar
                          </button>
                        </div>
                      </div>
                      {selectedPlaylist === pl.id && (
                        <div className="bg-slate-900 bg-opacity-80 p-4 rounded-lg mt-3 border border-slate-700">
                          <h4 className="text-white font-bold mb-3">Agregar canciones:</h4>
                          <div className="max-h-48 overflow-y-auto space-y-1 mb-3">
                            {allSongs.map(s => {
                              const isAlreadyInPlaylist = playlistSongs.some(ps => ps.id === s.id);
                              return (
                                <div key={s.id} onClick={() => !isAlreadyInPlaylist && setSelectedSongsToAdd(prev => prev.includes(s.id) ? prev.filter(id => id !== s.id) : [...prev, s.id])}
                                  className={'p-2 rounded cursor-pointer text-sm flex items-center gap-2 ' + 
                                    (isAlreadyInPlaylist ? 'bg-gray-800 opacity-60 cursor-not-allowed' : 
                                     selectedSongsToAdd.includes(s.id) ? 'bg-blue-600' : 'bg-slate-700 hover:bg-slate-600')}>
                                  <span>{isAlreadyInPlaylist ? '✓' : selectedSongsToAdd.includes(s.id) ? 'OK' : '+'}</span>
                                  <div className="flex flex-col">
                                    <span className="text-white leading-tight">{s.titulo} - {s.artista}</span>
                                    {isAlreadyInPlaylist && <span className="text-[9px] text-blue-400 font-bold uppercase tracking-tighter">YA EN PLAYLIST</span>}
                                  </div>
                                  <button onClick={(e) => { e.stopPropagation(); handlePushToRadio(s.id); }} 
                                    className="ml-auto bg-blue-900 hover:bg-blue-800 text-blue-200 text-[10px] px-2 py-1 rounded border border-blue-700">
                                    AL AIRE
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                          <button onClick={handleAddSongsToPlaylist} disabled={isLoading || selectedSongsToAdd.length === 0}
                            className="w-full bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white py-2 rounded-lg font-semibold mb-3">
                            {isLoading ? 'Agregando...' : 'Agregar ' + selectedSongsToAdd.length + ' canciones'}
                          </button>
                          <h4 className="text-white font-bold mb-2">En esta playlist:</h4>
                          <div className="max-h-48 overflow-y-auto space-y-1">
                            {playlistSongs.length > 0 ? playlistSongs.map((c, i) => (
                              <div key={c.id} className="bg-slate-700 p-2 rounded flex justify-between items-center">
                                <span className="text-white text-sm">{i + 1}. {c.titulo} - {c.artista}</span>
                                <button onClick={async () => { await fetch('/api/playlists/' + pl.id + '/remove-song/' + c.id, { method: 'DELETE' }); loadPlaylistSongs(pl.id); loadAdminData(); }}
                                  className="text-red-400 hover:text-red-300 text-xs px-2">X</button>
                              </div>
                            )) : <p className="text-gray-400 text-sm">Sin canciones</p>}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {adminTab === 'noticias' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Noticias y Comunicados</h2>
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 mb-6 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-4">Nueva Noticia</h3>
                  <div className="space-y-3">
                    <input type="text" placeholder="Titulo" value={newsForm.titulo}
                      onChange={(e) => setNewsForm({ ...newsForm, titulo: e.target.value })}
                      className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" />
                    <textarea placeholder="Contenido" value={newsForm.contenido}
                      onChange={(e) => setNewsForm({ ...newsForm, contenido: e.target.value })}
                      className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" rows="4" />
                    <div>
                      <label className="text-gray-400 text-sm mb-2 block">Adjuntar imagen o PDF (opcional):</label>
                      <input type="file" accept="image/*,.pdf" onChange={(e) => handleDocUpload(e.target.files[0])}
                        className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" />
                      {uploadingDoc && <p className="text-blue-400 text-xs mt-1">Subiendo...</p>}
                      {newsForm.documento_url && <p className="text-green-400 text-xs mt-1">Archivo subido</p>}
                    </div>
                    <button onClick={handleCreateNews} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold">
                      Publicar Noticia
                    </button>
                  </div>
                </div>
                <div className="space-y-3">
                  <h3 className="text-lg font-bold text-white">Publicadas ({noticias.length})</h3>
                  {noticias.map((n, i) => (
                    <div key={i} className="bg-black bg-opacity-40 p-4 rounded-xl border border-blue-500 backdrop-blur-md">
                      <div className="flex justify-between items-start mb-2">
                        <p className="text-white font-bold">{n.titulo}</p>
                        <button onClick={async () => { 
                          if (window.confirm('¿Eliminar esta noticia definitivamente?')) {
                            await fetch('/api/noticias/' + n.id, { method: 'DELETE' });
                            fetchNoticias();
                          }
                        }} className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-xs font-bold transition">
                          Borrar
                        </button>
                      </div>
                      <p className="text-gray-400 text-sm mt-1">{n.contenido}</p>
                      {n.documento_url && (
                        isImage(n.documento_url) ? (
                          <div className="mt-2 rounded overflow-hidden border border-slate-700 w-32">
                            <img src={n.documento_url} alt="Vista previa" className="w-full h-auto" />
                          </div>
                        ) : (
                          <a href={n.documento_url} target="_blank" rel="noopener noreferrer" className="text-blue-400 text-xs mt-2 inline-block hover:underline">
                            📄 Ver documento
                          </a>
                        )
                      )}
                    </div>
                  ))}
                  {noticias.length === 0 && <div className="bg-black bg-opacity-40 p-8 rounded-xl border border-blue-500 text-center backdrop-blur-md"><p className="text-gray-400">No hay noticias publicadas</p></div>}
                </div>
              </div>
            )}

            {adminTab === 'funas' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Administrar Funas</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {funas.map(f => (
                    <div key={f.id} className="bg-slate-800 bg-opacity-40 rounded-2xl border border-slate-700 overflow-hidden group relative">
                      <div className="absolute top-2 right-2 z-10">
                        <button onClick={async () => {
                          if (window.confirm('¿Borrar esta funa?')) {
                            await fetch('/api/funas/' + f.id, { method: 'DELETE' });
                            fetchFunas();
                          }
                        }} className="bg-red-600 hover:bg-red-700 text-white p-2 rounded-full shadow-lg transition">
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                      <div className="relative aspect-video">
                        <img src={f.foto_url} alt="Funa" className="w-full h-full object-cover" />
                        <div className="absolute bottom-2 left-2 bg-black bg-opacity-70 text-[10px] text-white px-2 py-1 rounded-full font-bold">
                          EXPIRA: {f.expira_en.split(' ')[1]}
                        </div>
                      </div>
                      <div className="p-4">
                        <span className="bg-red-900 text-red-200 text-[10px] px-2 py-0.5 rounded font-bold uppercase">{f.zona}</span>
                        <p className="text-sm text-gray-300 font-medium mt-2">{f.comentario || 'Sin descripción'}</p>
                        <p className="text-[10px] text-gray-500 mt-1">{f.creado_en}</p>
                      </div>
                    </div>
                  ))}
                  {funas.length === 0 && (
                    <div className="col-span-full bg-black bg-opacity-40 p-8 rounded-xl border border-blue-500 text-center backdrop-blur-md">
                      <p className="text-gray-400">No hay funas activas</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {adminTab === 'confesiones' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Moderación de Confesiones</h2>
                <div className="space-y-4">
                  {confesionesPendientes.length > 0 ? confesionesPendientes.map(conf => (
                    <div key={conf.id} className="bg-black bg-opacity-40 p-6 rounded-2xl border border-pink-500/30 backdrop-blur-md">
                      <div className="flex justify-between items-start mb-4">
                        <div className="flex-1">
                          <p className="text-pink-400 font-bold text-sm mb-1">{conf.pseudonimo}</p>
                          <p className="text-white text-lg italic">"{conf.contenido}"</p>
                          <p className="text-gray-500 text-[10px] uppercase font-black mt-2">
                            Enviada: {new Date(conf.fecha_envio).toLocaleString('es-CL')}
                          </p>
                        </div>
                        <span className="bg-yellow-500/20 text-yellow-500 text-[10px] font-black px-3 py-1 rounded-full border border-yellow-500/30">PENDIENTE</span>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <button 
                          onClick={async () => {
                            const res = await fetch('/api/confesiones/admin/moderate', {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: conf.id, estado: 'aprobado' })
                            });
                            if (res.ok) {
                              alert('Confesión aprobada');
                              loadAdminData();
                              fetchConfesiones();
                            }
                          }}
                          className="bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-bold transition flex items-center justify-center gap-2"
                        >
                          APROBAR
                        </button>
                        <button 
                          onClick={async () => {
                            if (!window.confirm('¿Rechazar esta confesión?')) return;
                            const res = await fetch('/api/confesiones/admin/moderate', {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: conf.id, estado: 'rechazado' })
                            });
                            if (res.ok) {
                              alert('Confesión rechazada');
                              loadAdminData();
                            }
                          }}
                          className="bg-red-600/20 hover:bg-red-600 text-red-500 hover:text-white py-3 rounded-xl font-bold transition border border-red-500/30"
                        >
                          RECHAZAR
                        </button>
                      </div>
                    </div>
                  )) : (
                    <div className="bg-black bg-opacity-40 p-12 rounded-2xl border border-slate-800 text-center backdrop-blur-md">
                      <Heart className="w-12 h-12 text-slate-700 mx-auto mb-4 opacity-30" />
                      <p className="text-gray-400 font-bold uppercase tracking-widest text-sm">No hay confesiones para moderar</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {adminTab === 'chat' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Moderación de Chat</h2>
                <div className="bg-black bg-opacity-40 rounded-xl overflow-x-auto border border-blue-500 backdrop-blur-md">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="bg-blue-600 bg-opacity-20 text-blue-400 text-[10px] uppercase tracking-widest font-black">
                        <th className="px-6 py-4">Usuario</th>
                        <th className="px-6 py-4">Mensaje</th>
                        <th className="px-6 py-4">Fecha</th>
                        <th className="px-6 py-4 text-right">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5">
                      {chatMessages.length > 0 ? [...chatMessages].reverse().map(m => (
                        <tr key={m.id} className="hover:bg-white/5 transition-colors">
                          <td className="px-6 py-4">
                            <span className="text-blue-400 font-bold text-sm">{m.autor}</span>
                          </td>
                          <td className="px-6 py-4 text-gray-300 text-sm max-w-md truncate">{m.mensaje}</td>
                          <td className="px-6 py-4 text-gray-500 text-xs">
                            {new Date(m.fecha).toLocaleString('es-CL')}
                          </td>
                          <td className="px-6 py-4 text-right">
                            <button 
                              onClick={() => handleDeleteChatMessage(m.id)}
                              className="p-2 bg-red-900/30 hover:bg-red-600 text-red-400 hover:text-white rounded-lg transition border border-red-500/20"
                              title="Borrar mensaje"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="4" className="px-6 py-10 text-center text-gray-500">No hay mensajes para moderar</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {adminTab === 'solicitudes' && (

              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Solicitudes</h2>
                {statsSolicitudes && (
                  <div className="grid grid-cols-4 gap-4 mb-6">
                    {[
                      { label: 'Total', value: statsSolicitudes.total, color: 'text-white' },
                      { label: 'Aprobadas', value: statsSolicitudes.aprobados, color: 'text-green-400' },
                      { label: 'Rechazadas', value: statsSolicitudes.rechazados, color: 'text-red-400' },
                      { label: 'Pendientes', value: statsSolicitudes.pendientes, color: 'text-yellow-400' },
                    ].map((s, i) => (
                      <div key={i} className="bg-black bg-opacity-40 p-4 rounded-xl border border-blue-500 text-center backdrop-blur-md">
                        <p className={'text-2xl font-bold ' + s.color}>{s.value}</p>
                        <p className="text-gray-400 text-xs mt-1">{s.label}</p>
                      </div>
                    ))}
                  </div>
                )}
                <div className="space-y-3">
                  {solicitudes.length > 0 ? solicitudes.map(sol => (
                    <div key={sol.id} className="bg-black bg-opacity-40 p-4 rounded-xl border border-blue-500 backdrop-blur-md">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <p className="text-white font-bold">{sol.solicitante}</p>
                          <p className="text-blue-300 text-sm">Cancion ID: {sol.cancion_id}</p>
                          <p className="text-gray-400 text-xs mt-1">{sol.comentario}</p>
                        </div>
                        <span className="bg-yellow-900 text-yellow-300 px-3 py-1 rounded text-xs font-bold">PENDIENTE</span>
                      </div>
                       <div className="grid grid-cols-3 gap-2">
                        <button onClick={async () => { await fetch('/api/requests/approve/' + sol.id, { method: 'POST' }); loadAdminData(); }}
                          className="bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg text-sm font-bold">Aprobar</button>
                        <button onClick={async () => { await fetch('/api/requests/reject/' + sol.id, { method: 'POST' }); loadAdminData(); }}
                          className="bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg text-sm font-bold">Rechazar</button>
                        <button onClick={() => handlePushToRadio(sol.cancion_id)}
                          className="bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm font-bold">Sonar Ahora</button>
                      </div>
                    </div>
                  )) : <div className="bg-black bg-opacity-40 p-8 rounded-xl border border-blue-500 text-center backdrop-blur-md"><p className="text-gray-400">No hay solicitudes pendientes</p></div>}
                </div>
              </div>
            )}

            {adminTab === 'enfermero_mes' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-white">Gestión Enfermero del Mes</h2>
                  <div className="bg-yellow-500/20 text-yellow-500 text-[10px] font-black px-3 py-1 rounded-full border border-yellow-500/30 uppercase tracking-widest">
                    MAYO 2026
                  </div>
                </div>
                
                <div className="bg-black bg-opacity-40 rounded-xl overflow-hidden border border-blue-500 backdrop-blur-md">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="bg-blue-600 bg-opacity-20 text-blue-400 text-[10px] uppercase tracking-widest font-black">
                        <th className="px-6 py-4">Nombre del Candidato</th>
                        <th className="px-6 py-4 text-center">Votos</th>
                        <th className="px-6 py-4 text-right">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5">
                      {nominaciones.length > 0 ? nominaciones.map((n, i) => (
                        <tr key={n.id} className="hover:bg-white/5 transition-colors">
                          <td className="px-6 py-4">
                            <div className="flex items-center gap-3">
                              <span className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs ${i === 0 ? 'bg-yellow-400 text-slate-900' : 'bg-slate-700 text-gray-400'}`}>
                                {i + 1}
                              </span>
                              <span className="text-white font-bold text-sm">{n.nombre}</span>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-center">
                            <span className="bg-blue-900/50 text-blue-400 px-3 py-1 rounded-full font-bold text-xs border border-blue-500/20">
                              {n.votos}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-right">
                            <div className="flex justify-end gap-2">
                              <button 
                                onClick={() => handleUpdateVotos(n.id, n.votos)}
                                className="p-2 bg-blue-900/30 hover:bg-blue-600 text-blue-400 hover:text-white rounded-lg transition border border-blue-500/20"
                                title="Editar votos"
                              >
                                <Settings className="w-4 h-4" />
                              </button>
                              <button 
                                onClick={() => handleDeleteNominacion(n.id)}
                                className="p-2 bg-red-900/30 hover:bg-red-600 text-red-400 hover:text-white rounded-lg transition border border-red-500/20"
                                title="Borrar postulación"
                              >
                                <Trash2 className="w-4 h-4" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="3" className="px-6 py-10 text-center text-gray-500 italic">No hay nominaciones registradas aún</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                
                <div className="mt-8 p-6 bg-blue-600/10 border border-blue-500/20 rounded-2xl">
                  <div className="flex items-start gap-4">
                    <Trophy className="w-6 h-6 text-yellow-400 mt-1" />
                    <div>
                      <h4 className="text-white font-bold text-sm mb-1">Información de Moderación</h4>
                      <p className="text-gray-400 text-xs leading-relaxed">
                        Como administrador, puedes eliminar postulaciones que no correspondan a personal de enfermería o que contengan lenguaje inapropiado. 
                        Los votos son acumulativos y se actualizan en tiempo real en la vista del oyente.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {adminTab === 'pymes' && (
              <div className="space-y-8">
                {/* HEADER */}
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl font-bold text-white flex items-center gap-2">
                    <Store className="text-blue-400" /> Gestión de Pautas / Pymes
                  </h2>
                  <div className="flex items-center gap-3">
                    <span className="bg-blue-600/20 text-blue-400 text-[10px] font-black px-4 py-2 rounded-full border border-blue-500/30 uppercase tracking-widest">
                      {pymesAdmin.filter(p => p.activo).length} activas · {pymesAdmin.length} total
                    </span>
                    {selectedPymes.length > 0 && (
                      <button
                        onClick={handleBulkDeletePymes}
                        className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-xs font-black flex items-center gap-2 transition"
                      >
                        <Trash2 size={14} /> Borrar seleccionadas ({selectedPymes.length})
                      </button>
                    )}
                  </div>
                </div>

                {/* FORMULARIO AGREGAR */}
                <div className="bg-black bg-opacity-40 rounded-xl p-8 border border-blue-500 backdrop-blur-md">
                  <h3 className="text-lg font-bold text-white mb-6 flex items-center gap-2">
                    <Plus className="text-blue-400" /> Agregar Nueva Pauta
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">Nombre del Negocio</label>
                      <input type="text" value={pymeForm.nombre_pyme}
                        onChange={(e) => setPymeForm({...pymeForm, nombre_pyme: e.target.value})}
                        className="w-full bg-slate-800 text-white border border-slate-700 rounded-xl px-4 py-3 focus:outline-none focus:border-blue-500"
                        placeholder="Ej: Cafetería Central" />
                    </div>
                    <div>
                      <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">Teléfono/WhatsApp</label>
                      <input type="text" value={pymeForm.telefono}
                        onChange={(e) => setPymeForm({...pymeForm, telefono: e.target.value})}
                        className="w-full bg-slate-800 text-white border border-slate-700 rounded-xl px-4 py-3 focus:outline-none focus:border-blue-500"
                        placeholder="Ej: +56912345678" />
                    </div>
                  </div>
                  <div className="mb-6">
                    <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">Descripción</label>
                    <textarea value={pymeForm.descripcion}
                      onChange={(e) => setPymeForm({...pymeForm, descripcion: e.target.value})}
                      className="w-full bg-slate-800 text-white border border-slate-700 rounded-xl px-4 py-3 h-20 focus:outline-none focus:border-blue-500"
                      placeholder="Breve descripción del negocio..." />
                  </div>
                  <div className="mb-6">
                    <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">Oferta Especial</label>
                    <input type="text" value={pymeForm.oferta}
                      onChange={(e) => setPymeForm({...pymeForm, oferta: e.target.value})}
                      className="w-full bg-slate-800 text-white border border-slate-700 rounded-xl px-4 py-3 focus:outline-none focus:border-blue-500"
                      placeholder="Ej: 15% de descuento mencionando la radio" />
                  </div>
                  <div className="mb-8">
                    <label className="block text-gray-400 text-xs font-bold mb-2 uppercase tracking-widest">Imagen Publicitaria</label>
                    <input type="file" accept="image/*"
                      onChange={(e) => setPymeForm({...pymeForm, file: e.target.files[0]})}
                      className="w-full text-sm text-gray-400 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700 cursor-pointer" />
                  </div>
                  <button onClick={handleCreatePymeAdmin} disabled={isUploadingPyme}
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-4 rounded-xl font-black transition shadow-lg disabled:opacity-50">
                    {isUploadingPyme ? 'SUBIENDO...' : '📡 PUBLICAR EN LA RADIO'}
                  </button>
                </div>

                {/* PANEL DE CONTROL DE PAUTAS */}
                <div className="bg-black bg-opacity-40 rounded-xl border border-blue-500 backdrop-blur-md overflow-hidden">
                  {/* Header panel */}
                  <div className="px-6 py-4 bg-blue-600/10 border-b border-blue-500/20 flex items-center justify-between">
                    <h3 className="text-white font-bold flex items-center gap-2">
                      <BarChart2 size={18} className="text-blue-400" /> Panel de Control de Pautas
                    </h3>
                    <div className="flex items-center gap-3 text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                      <span className="flex items-center gap-1"><span className="w-2 h-2 bg-green-500 rounded-full"></span> Activa</span>
                      <span className="flex items-center gap-1"><span className="w-2 h-2 bg-slate-500 rounded-full"></span> Pausada</span>
                      <span>Arrastrar = reordenar</span>
                    </div>
                  </div>

                  {/* Instrucciones drag */}
                  <div className="px-6 py-3 bg-blue-900/10 border-b border-slate-800 text-[10px] text-blue-300/60 font-bold uppercase tracking-wider flex items-center gap-2">
                    <span>↕</span> Usa los botones ▲▼ para reordenar la pauta que ve el público
                  </div>

                  {/* Lista de pymes con controles */}
                  <div className="divide-y divide-slate-800">
                    {pymesAdmin.length === 0 && (
                      <div className="py-16 text-center text-slate-600">
                        <Store className="w-10 h-10 mx-auto mb-3 opacity-30" />
                        <p className="font-bold uppercase tracking-widest text-sm">No hay pautas registradas</p>
                      </div>
                    )}
                    {pymesAdmin.map((pyme, idx) => (
                      <div key={pyme.id}
                        className={`flex items-center gap-4 px-6 py-4 transition-all ${pyme.activo ? 'bg-transparent hover:bg-white/3' : 'bg-slate-900/60 opacity-70'}`}>

                        {/* Checkbox selección */}
                        <input type="checkbox" checked={selectedPymes.includes(pyme.id)}
                          onChange={(e) => {
                            if (e.target.checked) setSelectedPymes(prev => [...prev, pyme.id]);
                            else setSelectedPymes(prev => prev.filter(id => id !== pyme.id));
                          }}
                          className="w-4 h-4 accent-blue-500 cursor-pointer flex-shrink-0" />

                        {/* Número de orden */}
                        <div className="w-8 h-8 rounded-full bg-slate-700/50 flex items-center justify-center text-[11px] font-black text-blue-400 flex-shrink-0">
                          {idx + 1}
                        </div>

                        {/* Imagen miniatura */}
                        <img src={getFullUrl(pyme.imagen_url)} alt={pyme.nombre_pyme}
                          className="w-14 h-14 object-cover rounded-xl border border-slate-700 flex-shrink-0" />

                        {/* Info */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-0.5">
                            <p className="text-white font-bold text-sm truncate">{pyme.nombre_pyme}</p>
                            {!pyme.activo && <span className="bg-slate-700 text-slate-400 text-[9px] font-black px-2 py-0.5 rounded uppercase">PAUSADA</span>}
                          </div>
                          <p className="text-gray-500 text-[10px] truncate">{pyme.descripcion}</p>
                          <div className="flex items-center gap-2 mt-1">
                            {pyme.oferta && <span className="bg-yellow-900/50 text-yellow-400 text-[9px] px-2 py-0.5 rounded font-bold">🎯 {pyme.oferta}</span>}
                            <span className="text-gray-600 text-[9px]">{pyme.telefono}</span>
                          </div>
                        </div>

                        {/* Controles */}
                        <div className="flex items-center gap-2 flex-shrink-0">
                          {/* Subir / Bajar orden */}
                          <div className="flex flex-col gap-1">
                            <button title="Subir en la pauta"
                              disabled={idx === 0}
                              onClick={async () => {
                                const newList = [...pymesAdmin];
                                [newList[idx - 1], newList[idx]] = [newList[idx], newList[idx - 1]];
                                setPymesAdmin(newList);
                                await fetch('/api/pymes/reorder', {
                                  method: 'POST',
                                  headers: { 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ ids: newList.map(p => p.id) })
                                });
                              }}
                              className="w-7 h-7 bg-slate-700 hover:bg-blue-600 disabled:opacity-20 text-white rounded text-xs font-black transition flex items-center justify-center">
                              ▲
                            </button>
                            <button title="Bajar en la pauta"
                              disabled={idx === pymesAdmin.length - 1}
                              onClick={async () => {
                                const newList = [...pymesAdmin];
                                [newList[idx + 1], newList[idx]] = [newList[idx], newList[idx + 1]];
                                setPymesAdmin(newList);
                                await fetch('/api/pymes/reorder', {
                                  method: 'POST',
                                  headers: { 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ ids: newList.map(p => p.id) })
                                });
                              }}
                              className="w-7 h-7 bg-slate-700 hover:bg-blue-600 disabled:opacity-20 text-white rounded text-xs font-black transition flex items-center justify-center">
                              ▼
                            </button>
                          </div>

                          {/* Toggle activo/pausado */}
                          <button
                            onClick={async () => {
                              const nuevoEstado = !pyme.activo;
                              await fetch(`/api/pymes/${pyme.id}/toggle`, {
                                method: 'PATCH',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ activo: nuevoEstado })
                              });
                              setPymesAdmin(prev => prev.map(p => p.id === pyme.id ? {...p, activo: nuevoEstado ? 1 : 0} : p));
                            }}
                            className={`px-3 py-2 rounded-lg text-[10px] font-black uppercase transition border ${
                              pyme.activo
                                ? 'bg-green-600/20 text-green-400 border-green-500/30 hover:bg-green-600/40'
                                : 'bg-slate-700 text-slate-400 border-slate-600 hover:bg-slate-600'
                            }`}
                            title={pyme.activo ? 'Pausar pauta' : 'Activar pauta'}>
                            {pyme.activo ? '✓ ACTIVA' : '⏸ PAUSAR'}
                          </button>

                          {/* Borrar individual */}
                          <button
                            onClick={async () => {
                              if (!window.confirm(`¿Eliminar permanentemente "${pyme.nombre_pyme}"?`)) return;
                              await fetch(`/api/pymes/${pyme.id}`, { method: 'DELETE' });
                              setPymesAdmin(prev => prev.filter(p => p.id !== pyme.id));
                              setSelectedPymes(prev => prev.filter(id => id !== pyme.id));
                            }}
                            className="w-9 h-9 bg-red-900/30 hover:bg-red-600 text-red-400 hover:text-white rounded-lg transition border border-red-500/20 flex items-center justify-center"
                            title="Eliminar pauta">
                            <Trash2 size={15} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Footer con acciones masivas */}
                  {pymesAdmin.length > 0 && (
                    <div className="px-6 py-4 bg-slate-900/50 border-t border-slate-800 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <input type="checkbox"
                          checked={selectedPymes.length === pymesAdmin.length && pymesAdmin.length > 0}
                          onChange={(e) => {
                            if (e.target.checked) setSelectedPymes(pymesAdmin.map(p => p.id));
                            else setSelectedPymes([]);
                          }}
                          className="w-4 h-4 accent-blue-500 cursor-pointer" />
                        <span className="text-gray-400 text-xs font-bold">Seleccionar todo</span>
                      </div>
                      <div className="flex items-center gap-2 text-[10px] text-gray-500">
                        <span>{pymesAdmin.filter(p => p.activo).length} activas</span>
                        <span>·</span>
                        <span>{pymesAdmin.filter(p => !p.activo).length} pausadas</span>
                        <span>·</span>
                        <span>{pymesAdmin.length} total</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* VISTA PREVIA DE LO QUE VE EL PÚBLICO */}
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-slate-700 backdrop-blur-md">
                  <h3 className="text-white font-bold mb-4 text-sm uppercase tracking-widest flex items-center gap-2">
                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                    Vista previa — Lo que ve el público ahora
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {pymesAdmin.filter(p => p.activo).map((pyme, i) => (
                      <div key={pyme.id} className="bg-slate-800/50 rounded-xl p-3 border border-slate-700/50 text-center">
                        <div className="text-[9px] text-blue-400 font-black mb-1">SLOT {i + 1}</div>
                        <img src={getFullUrl(pyme.imagen_url)} alt={pyme.nombre_pyme}
                          className="w-12 h-12 object-cover rounded-lg mx-auto mb-2" />
                        <p className="text-white text-[10px] font-bold truncate">{pyme.nombre_pyme}</p>
                      </div>
                    ))}
                    {pymesAdmin.filter(p => p.activo).length === 0 && (
                      <div className="col-span-full text-center py-6 text-gray-600 text-xs italic">
                        No hay pautas activas — el bloque no aparecerá en el frontend
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}




            {adminTab === 'configuracion' && (
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Configuracion</h2>
                <div className="bg-black bg-opacity-40 rounded-xl p-6 border border-blue-500 backdrop-blur-md space-y-4">
                  <div><label className="text-white text-sm mb-2 block font-semibold">Hospital / Capitulo</label>
                    <input type="text" defaultValue="Hospital Provincial de Ovalle" className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" /></div>
                  <div><label className="text-white text-sm mb-2 block font-semibold">Duracion maxima de batalla (minutos)</label>
                    <input type="number" defaultValue="60" className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" /></div>
                  <div><label className="text-white text-sm mb-2 block font-semibold">Intervalo minimo entre batallas (minutos)</label>
                    <input type="number" defaultValue="3" className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600" /></div>
                  <div className="bg-slate-800 bg-opacity-60 p-4 rounded-lg">
                    <p className="text-white font-semibold mb-2">Bloqueo de acceso externo</p>
                    <p className="text-green-400 text-sm">✅ Solo accesible desde red del hospital</p>
                    <p className="text-gray-400 text-xs mt-1">IPs: 192.168.10.0/24 y 201.120.55.88</p>
                  </div>
                  <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold">Guardar Cambios</button>
                </div>
              </div>
            )}

          </main>
        </div>
      )}

      {/* MODAL DE EDICIÓN DE CANCIÓN */}
      {isEditModalOpen && editingSong && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black bg-opacity-70 backdrop-blur-md" onClick={() => setIsEditModalOpen(false)}></div>
          <div className="relative bg-slate-900 border border-blue-500 rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden animate-in zoom-in duration-300">
            <div className="bg-blue-600 p-6 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                  <Pencil className="w-5 h-5 text-white" />
                </div>
                <h2 className="text-xl font-black text-white uppercase tracking-tight">Editar Canción</h2>
              </div>
              <button onClick={() => setIsEditModalOpen(false)} className="text-white hover:rotate-90 transition-transform">
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <form onSubmit={handleUpdateSong} className="p-8 space-y-6">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-blue-400 uppercase tracking-widest block">Título del Tema</label>
                <div className="relative">
                  <Music className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                  <input 
                    type="text" 
                    value={editingSong.titulo} 
                    onChange={(e) => setEditingSong({...editingSong, titulo: e.target.value})}
                    className="w-full bg-slate-800 border border-slate-700 text-white pl-12 pr-4 py-4 rounded-xl focus:border-blue-500 focus:outline-none transition-colors font-bold"
                    placeholder="Título de la canción"
                    required
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black text-blue-400 uppercase tracking-widest block">Artista</label>
                <div className="relative">
                  <User className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                  <input 
                    type="text" 
                    value={editingSong.artista} 
                    onChange={(e) => setEditingSong({...editingSong, artista: e.target.value})}
                    className="w-full bg-slate-800 border border-slate-700 text-white pl-12 pr-4 py-4 rounded-xl focus:border-blue-500 focus:outline-none transition-colors font-bold"
                    placeholder="Nombre del artista"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black text-blue-400 uppercase tracking-widest block">Duración (segundos)</label>
                <div className="relative">
                  <Clock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                  <input 
                    type="number" 
                    value={editingSong.duracion} 
                    onChange={(e) => setEditingSong({...editingSong, duracion: parseInt(e.target.value)})}
                    className="w-full bg-slate-800 border border-slate-700 text-white pl-12 pr-4 py-4 rounded-xl focus:border-blue-500 focus:outline-none transition-colors font-bold"
                    placeholder="Duración en segundos"
                  />
                </div>
              </div>

              <div className="pt-4 flex gap-4">
                <button 
                  type="button" 
                  onClick={() => setIsEditModalOpen(false)}
                  className="flex-1 bg-slate-800 hover:bg-slate-700 text-white py-4 rounded-xl font-bold uppercase text-xs tracking-widest transition"
                >
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  disabled={isLoading}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:bg-slate-700 text-white py-4 rounded-xl font-black uppercase text-xs tracking-widest transition flex items-center justify-center gap-2"
                >
                  {isLoading ? 'Guardando...' : (
                    <>
                      <Save className="w-4 h-4" />
                      Guardar
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer className="radio-footer">
        <div className="radio-footer__inner">
          <p>Radio ASENF © 2026 | Desarrollada por Yohnnier Gomez de Innova Lab | Estado: ✅ Operacional</p>
          <p className="mt-1 text-xs">Para enfermeros, por enfermeros</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
